/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyImpactByEventWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAnomalyImpactByEventWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostAnomalyImpactByEventWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyImpactByEventWidgetConfiguration>): CostAnomalyImpactByEventWidgetConfiguration {
        let obj = Object.assign(new CostAnomalyImpactByEventWidgetConfiguration(), model);
        CostAnomalyImpactByEventWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyImpactByEventWidgetConfiguration>): CostAnomalyImpactByEventWidgetConfiguration {
        if (!model) return null;
        return CostAnomalyImpactByEventWidgetConfiguration.newInstance(<CostAnomalyImpactByEventWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyImpactByEventWidgetConfiguration) {
        if (!obj) return;

        models.CostAnomalyImpactByEventWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyImpactByEventWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalyImpactByEventWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of Category
     */
    categoryType: models.CategoryType;

}
